export default __webpack_public_path__ + "static/media/default_image.601166c9.jpeg";